import { useContext } from 'react';

import type { FeatureFlagsContextType, FlagSet } from 'contexts/featureFlags';
import { FeatureFlagsContext } from 'contexts/featureFlags';

export { useLDClient } from 'launchdarkly-react-client-sdk';

const noFlags: FeatureFlagsContextType = {
  flags: {},
  monitoredFlags: {},
  identify: undefined,
};

export const useFeatureFlags = <
  T extends FlagSet = FlagSet,
>(): FeatureFlagsContextType<T> => {
  return useContext(FeatureFlagsContext) || noFlags;
};
